var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 10,
    fill: "#3AB44A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.243 10.3c-.316-1.304-2.17-1.304-2.486 0a1.28 1.28 0 0 1-1.909.79c-1.145-.697-2.456.613-1.758 1.758a1.28 1.28 0 0 1-.79 1.91c-1.304.316-1.304 2.17 0 2.486a1.28 1.28 0 0 1 .79 1.909c-.698 1.145.613 2.456 1.758 1.758a1.28 1.28 0 0 1 1.909.79c.316 1.304 2.17 1.304 2.486 0a1.28 1.28 0 0 1 1.909-.79c1.145.697 2.456-.613 1.758-1.759a1.28 1.28 0 0 1 .79-1.908c1.304-.317 1.304-2.17 0-2.487a1.28 1.28 0 0 1-.79-1.909c.698-1.145-.613-2.455-1.758-1.758a1.28 1.28 0 0 1-1.909-.79ZM16 18.505a2.504 2.504 0 1 0 0-5.009 2.504 2.504 0 0 0 0 5.009Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingActive);
export default __webpack_public_path__ + "static/media/setting-active.77aef182b63ed9a1db5a0f8fd249d3b4.svg";
export { ForwardRef as ReactComponent };